<div class="flex flex-col gap-4">
  <div class="proffeo-ui-surface-card grid grid-cols-1 items-start gap-4 p-3 sm:grid-cols-2">
    @if (companyItems().length > 0 || companyId()) {
      <proffeo-ui-select
        (valueChange)="onCompanyChange($event)"
        [formField]="selection().company"
        [options]="companyItems()"
        [translateLabels]="false"
        errorMessage="ui-forms-this-field-is-required"
        label="time-reports-form-modal-select-company"
      />
    }

    <ng-content select="[beside-company]" />
  </div>

  <ng-content select="[between-company-and-project]" />

  @if (projectItems().length > 0 || projectId()) {
    <proffeo-ui-select
      (valueChange)="onProjectChange($event)"
      [formField]="selection().project"
      [options]="projectItems()"
      [translateLabels]="false"
      errorMessage="ui-forms-this-field-is-required"
      label="projects-menu-select-a-project"
    />
  } @else if (companyId() && !readonly()) {
    <p class="text-proffeo-disabled text-sm py-2">
      {{ 'loading-projects' | translate }}
    </p>
  }

  @if (taskItems().length > 0 || taskId()) {
    <proffeo-ui-select
      (valueChange)="onTaskChange($event)"
      [formField]="selection().task"
      [options]="taskItems()"
      [searchable]="true"
      [translateLabels]="false"
      errorMessage="ui-forms-this-field-is-required"
      label="select-task"
    />
  } @else if (projectId() && !readonly()) {
    @if (tasksLoading()) {
      <p
        role="status"
        class="text-sm py-2"
      >
        {{ 'loading-tasks' | translate }}
      </p>
    } @else if (showNoProjectTasksState()) {
      <proffeo-ui-empty-state
        title="time-reports-form-modal-no-project-tasks-title"
        description="time-reports-form-modal-no-project-tasks-description"
        icon="assignment"
        variant="no-data"
      />
    }
  }

  @if (showLocationPicker()) {
    <proffeo-ui-tree-select
      [formField]="selection().location"
      [nodes]="locationNodes()"
      [searchable]="true"
      [translateLabels]="false"
      placeholder="select-location"
      class="w-full"
    />
  }
</div>
